import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  'client-id',
  'client-secret',
] as const
const locationCredentialTypes = [
  accountNumber,
  'client-id',
  'client-secret',
] as const // SMTL may require per-location OAuth client credentials.

export type smtlCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]
export const smtlDocumentTypes = [
  'inspection-certificate',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const smtl: CarrierDef<smtlCredType> = {
  name: 'Southwestern Motor Transport',
  scac: 'smtl',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['account-number', 'ref1'],
    ['client-id', 'clientId'],
    ['client-secret', 'clientSecret'],
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'tracking',
    'documents',
    'cancel',
    'profinder',
  ],
  documentTypes: smtlDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
